/**
 * Make field with readonly class not accessible with tab
 *
 * @param {string} className class name
 */
function readOnlyField(className) {
  const fields = document.querySelectorAll(className);
  fields.forEach((field) => {
    field.tabIndex = -1;
  });
}

readOnlyField(".readonly-field__general");

export default readOnlyField;
